<script lang="ts">//
import AppHeader from './components/AppHeader.svelte'
import MobileNavigation from './components/MobileNavigation.svelte'
import AppFooter from './components/AppFooter.svelte'
import { page } from './store/navigation'
import router from './plugins/router'

router()
</script>

<main class="container pt-24">
	<MobileNavigation />
	<AppHeader />
	<svelte:component this={$page} />
	<AppFooter />
</main>

<style lang="postcss" global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	body {
		min-width: 300px;
	}

	.container {
		max-width: 1200px;
		margin: auto;
	}
</style>